import {NgModule} from "@angular/core";
import {SigneringStatusKomponentAvhengigheter} from "./komponenter/signering-status/signering-status";
import {SigneringSendPåminnelseDialogKomponentAvhengigheter} from "./modale/signering-send-påminnelse-dialog/signering-send-påminnelse-dialog";
import {SigneringSignerDialogKomponentAvhengigheter} from "web-ng2/moduler/signering/modale/signering-signer-dialog/signering-signer-dialog";
import {SigneringCriiptoKomponentAvhengigheter} from "web-ng2/moduler/signering/komponenter/signering-criipto/signering-criipto";
import {SigneringAvsluttDialogKomponentAvhengigheter} from "web-ng2/moduler/signering/modale/signering-avslutt-dialog/signering-avslutt-dialog";
import {SigneringOtpDialogKomponentAvhengigheter} from "web-ng2/moduler/signering/modale/signering-otp-dialog/signering-otp-dialog";
import {SigneringBankIDQESTjeneste} from "web-ng2/moduler/signering/tjenester/signering-bankid-qes-service";

@NgModule({
    providers: [
        SigneringStatusKomponentAvhengigheter,
        SigneringSendPåminnelseDialogKomponentAvhengigheter,
        SigneringSignerDialogKomponentAvhengigheter,
        SigneringOtpDialogKomponentAvhengigheter,
        SigneringCriiptoKomponentAvhengigheter,
        SigneringStatusKomponentAvhengigheter,
        SigneringAvsluttDialogKomponentAvhengigheter,
        SigneringBankIDQESTjeneste,
    ]
})
export class SigneringModul {

}
